import { MontarFormulario } from './montar-formulario';

(new MontarFormulario()).montar();
